

import React, { useState, useEffect, useContext, useRef } from 'react';
//import RoleService from "../../../../services/SetupService/RoleService/RoleService";
import TaxCodeService from "../../controller/TaxCodesController/TaxCodeController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateTaxCode from './CreateTaxCode';
import HelpSite from "../../../Common/HelpLink";
import Cookies from "js-cookie";
function TaxCodeListPage() {
    const navigate = useNavigate();
    const [taxCodeList, setTaxCodes] = useState([]);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [modalInstance, setModalInstance] = useState(null);
    const [currentTaxCode, setCurrentTaxCode] = useState(null);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`TaxSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`TaxSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    const fetchTaxCodes = async (page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const taxCodeData = await TaxCodeService.GetAllTaxCodes(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setTaxCodes(taxCodeData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    useEffect(() => {
        fetchTaxCodes(currentPage, pageSize);

    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchTaxCodes(currentPage, pageSize);

    }, [sortConfig]);



    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('taxCodeModal')));
    }, []);

    const handleCreateTaxCodeClick = () => {
        setCurrentTaxCode(null);
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };
    const handleSuccess = () => {
        fetchTaxCodes("0",pageSize);
    };
    

    const handleEditClick = (tax) => {
        setCurrentTaxCode(tax); // Set the team to be edited
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this team?");
        if (confirmed) {
            try {
                await TaxCodeService.DeleteTaxCode(ID);
                await fetchTaxCodes("0",pageSize); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Team:', error);
            }
        }
    };
    const handleTaxCodeToggle = async (event, ID) => {
        try {
            event.stopPropagation();
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            await TaxCodeService.SetDefaultTaxCode(ID);
            fetchTaxCodes();

        } catch (error) {
            console.error('API request failed:', error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');

    const tableRef = useRef();

    const defaultColumns = [
        "vc_Code",
        "dec_Rate",
        "vc_Description"
    ];
    const defaultColumnsForSearch = [
        "vc_Code",
        "dec_Rate",
        "vc_Description"

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "vc_Code", label: "vc_Code" },
        { value: "dec_Rate", label: "dec_Rate" },
        { value: "vc_Description", label: "vc_Description" }

    ];
    const columnSearchOptions = [
        { value: "vc_Code", label: "vc_Code" },
        { value: "dec_Rate", label: "dec_Rate" },
        { value: "vc_Description", label: "vc_Description" }

    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`taxColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`taxColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page


        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await TaxCodeService.GetAllTaxCodes(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setTaxCodes(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await TaxCodeService.GetAllTaxCodes(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setTaxCodes(locationData);

    };
    return (
        <div>

            <div className="row mb-3">

                <div className="col-sm-3">

                    <Link className='btn btn-primary btn-sm' onClick={handleCreateTaxCodeClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Tax Code" Module="26" />
                </div>
            </div>
            <div className="row mb-3">

                <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                    </select>
                </div>
                <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                <div className="col-sm-6"></div>
                <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>


                </div>
                <div className="col-sm-2 d-flex justify-content-end">
                    <input
                        list="recent-searches"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="form-control me-2"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchButtonClick();
                            }
                        }}
                    />

                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                        <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                </div>



            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>

                        <th onClick={() => handleSort('vc_Code')}>Tax Code</th>
                        <th onClick={() => handleSort('dec_Rate')}>Tax Rate (%)</th>
                        <th onClick={() => handleSort('vc_Description')}>Description</th>
                        <th>Default</th>
                        <th style={{ "textAlign": "right" }}>Actions</th>
                    </tr>
                </thead><tbody>

                    {taxCodeList.map((tax, index) => (

                        <tr key={tax.ID} onClick={() => handleEditClick(tax)}>

                            <td>{tax.vc_Code}</td>

                            <td>{tax.dec_Rate}</td>
                            <td>{tax.vc_Description}</td>
                            <td>
                                <button style={{ "padding": "4px 5px" }}
                                    className={`btn ${tax.IsDefault === 1 ? 'btn btn-primary btn-sm' : 'btn btn-secondary btn-sm'}`}
                                    onClick={(event) => handleTaxCodeToggle(event, tax.ID)}
                                >
                                    {tax.IsDefault === 1 ? 'On' : 'Off'}
                                </button>
                            </td>
                            <td style={{ "textAlign": "right" }}>

                                <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteClick(tax.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <CreateTaxCode tax={currentTaxCode} onClose={handleCloseModal} onSuccess={handleSuccess} />
        </div>
    );
}

export default TaxCodeListPage;